"use client";

import { useSession } from "@/lib/auth-client";
import { useRouter, usePathname } from "next/navigation";
import { useEffect } from "react";
import { LoadingSpinner } from "../ui/loading-spinner";

const PROTECTED_ROUTES = ["/dashboard", "/org"];

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const { data: session, isPending } = useSession();
  const router = useRouter();
  const pathname = usePathname();

  useEffect(() => {
    if (!isPending) {
      if (session?.user && pathname === "/auth") {
        router.push("/");
      } else if (
        !session?.user &&
        (PROTECTED_ROUTES.some((route) => pathname.startsWith(route)) ||
          pathname.startsWith("/org/"))
      ) {
        router.push("/");
      }
    }
  }, [session, isPending, pathname, router]);

  useEffect(() => {
    window["_msUserEmail"] = session?.user.email || null;
  }, [session?.user.email]);

  if (isPending) {
    return <LoadingSpinner />;
  }

  return <>{children}</>;
}
